import { render, staticRenderFns } from "./mainContacts2.vue?vue&type=template&id=1ac9c738"
import script from "./mainContacts2.vue?vue&type=script&lang=js"
export * from "./mainContacts2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports